import { Children, isValidElement } from 'react';

const getChildren = (children) => {
  const newChildren = Children.map(children, (child) => child);
  if (!newChildren)
    return [];
  return newChildren.filter((child) => !!child);
};
const defaultFunction = () => {
};
const defaultObject = {};
const defaultPromises = () => new Promise(defaultFunction);
const filteredChildren = (children, type) => Children.map(
  children,
  (child) => {
    if (!isValidElement(child))
      return;
    if ((child == null ? void 0 : child.type) !== type)
      return;
    return child;
  }
);
const createPortalDOMNode = (name, id) => {
  if (typeof window === "undefined")
    return null;
  const newPortalNode = document.createElement("div");
  const portalNodeName = name ? `-${name}` : "";
  const portalNodeId = id != null ? id : `artisn-ui${portalNodeName}-${new Date().getTime()}`;
  newPortalNode.setAttribute("id", portalNodeId);
  document.body.appendChild(newPortalNode);
  return newPortalNode;
};

export { createPortalDOMNode, defaultFunction, defaultObject, defaultPromises, filteredChildren, getChildren };
//# sourceMappingURL=bundle.esm2.js.map
